import styled from 'styled-components';

const UlHeader = styled.ul`
  display: inline-block;
  font-size: 24px;
  margin: 0 8px;
`;

export default UlHeader;
